import styled from 'styled-components';

const ButtonWrap = styled.div`
    display: flex;
`;

export default ButtonWrap;